module.exports = __webpack_public_path__ + "img/chilun_img3.2b54e936.png";